<!-- <div class="p-col-12">
<p-steps [model]="dataSubmitSteps" [activeIndex]="activeIndex"></p-steps>
</div> -->
<div>
  <!-- <input type="file" #submitFileInput (change)="onFileInput(submitFileInput.files)" /> -->
</div>
<p-card>
  <ng-template pTemplate="title">Upload result files</ng-template>
  <ng-template pTemplate="subtitle">
    Select, upload and review data
  </ng-template>
  <ng-template pTemplate="content">
    <div class="flex flex-column pb-6">
      <input type="file" class="file-input" (change)="onSelectFile($event)" #fileUpload hidden="true" />

      <div>
        <div class="flex flex-row justify-content-between align-content-center flex-wrap">
          <input id="selectedFile" type="text" pInputText placeholder="Please select a file for upload."
            value="{{ file?.name || 'Please select a file for upload.' }}" [disabled]="progress" class="flex flex-grow-1"/>
          <p-select [options]="dataLicenses" [(ngModel)]="dataLicense"
            [style]="{'width':'350px', 'min-width':'350px'}" [disabled]="progress" [checkmark]="true"
            placeholder="Please select a data license for the file!">
            <ng-template let-dataLicense pTemplate="item">
              <div class="flex items-center gap-2">
                <div>{{ dataLicense.licenseName }}&nbsp;({{ 'LICENSES.'+dataLicense.licenseId | uppercase | translate
                }})</div>
              </div>
            </ng-template>
            <ng-template pTemplate="selectedItem">
              @if (dataLicense) {
                <div class="flex items-center gap-2">
                  <div>{{ dataLicense.licenseName }}&nbsp;({{ 'LICENSES.'+dataLicense.licenseId | uppercase | translate
                  }})</div>
                </div>
              }
            </ng-template>
          </p-select>
          <p-buttongroup>
            <button pButton type="button" label="Select" (click)="fileUpload.click()" icon="far fa-folder-open"
            iconPos="left" class="p-button-primary" [disabled]="progress"></button>
            <button pButton type="button" label="Upload" (click)="myCustomUpload($event)" icon="fas fa-upload"
            iconPos="left" class="p-button-success" [disabled]="!isFormValid()"></button>
            <button pButton type="button" label="Clear" (click)="clear()" icon="fas fa-times" iconPos="left"
            class="p-button-danger" [disabled]="!file"></button>
          </p-buttongroup>
        </div>
        <div class="p-2">
          @if (!(isFileSelectionValid()) && !progress) {
            <small class="p-error block">Please select a file for upload!</small>
          }
          @if (!(isLicenseValid()) && !progress) {
            <small class="p-error block">Please select a data license for the file!</small>
          }
          @if (fileExists() && !progress) {
            <small class="p-error block">Please check that you are not trying to upload
            the same file. A file with name '{{ file.name }}' already exists!</small>
          }
        </div>
      </div>
    </div>
    <div class="flex flex-column p-2">
      <!-- Keyed so it does not also answer the unkeyed confirmations raised by
           the parent DataSubmitComponent, whose dialog is mounted at the same
           time (this component renders in its router-outlet). -->
      <p-confirmDialog
        #cdUploadDelete
        key="uploadDeleteFile"
        header="Confirmation"
        icon="fas fa-exclamation-triangle"
        rejectIcon="fas fa-times p-button-warning"
        rejectButtonStyleClass="p-button-danger"
        acceptIcon="fas fa-check"
        acceptButtonStyleClass="p-button-success"
        >
      </p-confirmDialog>
      <div class="p-card-title">Files in submission</div>
      <p-table class="w-full" [value]="submittedFileRows()" id="userSubmissions" [scrollable]="true"
        [scrollHeight]="'500px'" [paginator]="true" [rows]="10" [loading]="progress">
        <ng-template pTemplate="header">
          <tr>
            <th>File Name</th>
            <th>File Type</th>
            <th>License</th>
            <th>SHA-256 Hash</th>
            <th>Actions</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-submittedFile>
          <tr>
            <td>{{ submittedFile.fileName }}</td>
            <td>{{ submittedFile.fileType }}</td>
            <td>{{ submittedFile.dataLicense?.licenseName }} ({{ 'LICENSES.' + submittedFile.dataLicense?.licenseId |
            uppercase | translate }})</td>
            <td>{{ submittedFile.sha256Hash }}</td>
            <td>
              <div class="file-list-action pl-2">
                <button pButton type="button" class="p-button-danger" icon="fas fa-times" label="Delete"
                (click)="deleteFile(submittedFile)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
      <div class="p-2">
        @if (!hasMzTabFiles() && !progress) {
          <small class="p-error block">Please upload at least one mzTab-M file to
          proceed!</small>
        }
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    @if (submission) {
      <div class="flex justify-content-between flex-wrap flex-row"
        >
        <p-buttongroup>
          <button pButton type="button" label="Back" (click)="previousPage($event)" icon="fa fa-chevron-left"
          iconPos="left"></button>
          <!-- TODO: add help dialogs -->
          <!-- <p-button icon="fa fa-question" class="p-button-primary" label="Help"></p-button> -->
          <button pButton type="button" label="Cancel" (click)="cancel($event)" icon="fa fa-times" iconPos="right"
          class="p-button-danger"></button>
        </p-buttongroup>
        <button pButton type="button" label="Next" (click)="nextPage($event)" icon="fa fa-chevron-right"
        iconPos="right" [disabled]="!hasMzTabFiles()"></button>
      </div>
    }
  </ng-template>
</p-card>